const register = {
  loginCredentials: "Thông tin đăng nhập", // translated 
  companyInformation: "Thông tin công ty", // translated 
  contactDetails: "Thông tin liên hệ", // translated 
  businessName: "Tên doanh nghiệp", // translated 
  businessAddress: "Địa chỉ kinh doanh", // translated 
  registrationCode: "Mã đăng ký", // translated 
  businessRegistrationNumber: "Số đăng ký kinh doanh", // translated 
  websiteUrl: "URL trang web", // translated 
  mobilePhone: "Điện thoại di động", // translated 
  regionStateProvince: "Vùng/Tiểu bang/Tỉnh", // translated 
  legalTitle: "Chức danh pháp lý", // translated 
  city: "Thành phố", // translated 
  postalCode: "Mã bưu chính", // translated 
  registrationSuccess: "Đăng ký thành công.", // translated 
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome:
    "Vui lòng chờ một lát và bạn sẽ được chuyển hướng đến trang chủ.", // translated 
  usernameEmail: "Tên người dùng (Email)", // translated 
  password: "Mật khẩu", // translated 
  verifyPassword: "Xác minh mật khẩu", // translated 
  documents: "Tài liệu", // translated 
  termsAndConditionsSection: "Điều khoản và điều kiện", // translated 
  certificateOfIncorporation: "Giấy chứng nhận thành lập công ty", // translated 
  acceptTermsAndConditions: "Chấp nhận Điều khoản & Điều kiện", // translated 
  country: "Quốc gia", // translated 
  brandName: "Tên thương hiệu", // translated 
  register: "Đăng ký", // translated 
  isRequired: "Cần thiết", // translated 
  passwordMin8Chars: "Phải có ít nhất 8 ký tự.", // translated 
  passwordRequiresDigit: "Phải chứa ít nhất 1 chữ số", // translated 
  passwordRequiresLowercase: "Phải chứa ít nhất 1 chữ cái thường.", // translated 
  passwordRequiresUppercase: "Phải chứa ít nhất 1 chữ cái viết hoa.", // translated 
  passwordRequiresSpecialChar: 'Phải chứa ít nhất 1 ký tự đặc biệt (!@#$%^&*(),.?":{}|<>)', // translated 
  uploadFile: "Tải lên tệp", // translated 
  filename: "Tên tệp:", // translated 
  fileType: "Kiểu:", // translated 
  fileSize: "Kích cỡ:", // translated 
  maxFileSize10Mb: "Tối đa: 10MB", // translated 
  supportedFileTypes: "Các loại tệp được hỗ trợ:", // translated 
  showPassword: "Hiển thị mật khẩu", // translated 
  hidePassword: "Ẩn mật khẩu", // translated 
  notAvailable: "Không áp dụng", // translated 
  fileSizeInKb: "{{size}} KB", // translated 
  mobilePhonePlaceholder: "Ví dụ: +12025550123", // translated 
  websiteUrlPlaceholder: "http://www.example.com", // translated 
  loading: "Đang tải...", // translated 
  uploadingDocument: "Đang tải tài liệu...", // translated 
  percentUploaded: "{{percent}}% đã tải lên", // translated 
  registrationSuccessful: "Đăng ký thành công.", // translated 
  failedToUploadDocument: "Tải tài liệu lên không thành công.", // translated 
  fieldIsRequired: "{{field}} {{isRequired}}", // translated 
  fieldMinLength: "{{field}} phải dài hơn {{min}} ký tự", // translated 
  fieldMustBeValidEmail: "{{field}} phải là một địa chỉ email hợp lệ.", // translated 
  fieldPasswordMinLength: "{{field}} phải có ít nhất 8 ký tự", // translated 
  fieldPasswordRequiresDigit: "{{field}} phải chứa ít nhất 1 chữ số", // translated 
  fieldPasswordRequiresLowercase: "{{field}} phải chứa ít nhất 1 chữ cái viết thường", // translated 
  fieldPasswordRequiresUppercase: "{{field}} phải chứa ít nhất 1 chữ cái viết hoa", // translated 
  fieldPasswordRequiresSpecialChar:
    '{{field}} phải chứa ít nhất 1 ký tự đặc biệt (!@#$%^&*(),.?":{}|<>)', // translated 
  passwordsDoNotMatch: "{{field}} không khớp với {{otherField}}", // translated 
  fieldBetweenLength: "{{field}} phải nằm trong khoảng từ {{min}} đến {{max}} ký tự.", // translated 
  postalCodeBetweenLength: "Mã {{field}} phải nằm trong khoảng từ {{min}} đến {{max}} ký tự.", // translated 
  invalidUrlFormat: "Định dạng URL không hợp lệ", // translated 
  invalidEmailFormat: "Định dạng email không hợp lệ", // translated 
  emailMustMatchUsername: "Địa chỉ email phải giống với tên người dùng (email).", // translated 
  mobilePhoneIsRequired: "Cần có điện thoại di động.", // translated 
  certificateFileTooLarge: "Tệp chứng chỉ quá lớn", // translated 
  termsMustBeAccepted: "Bạn phải chấp nhận các Điều khoản và Điều kiện.", // translated 
};


export default register;
